export const resolveOriginalArtwork = (artworkUrl: string) => {
  const noThumbUrl = artworkUrl.replace(/c_fit,h_\d+,w_\d+/gi, '');

  return noThumbUrl.replace('upload//', 'upload/');
};
